// extracted by mini-css-extract-plugin
export default {"privacyPolicy":"Privacypolicy_privacyPolicy__lvYV8","container":"Privacypolicy_container__EJZYN","title":"Privacypolicy_title__pdJbg"};